module.exports = __webpack_public_path__ + "img/about6.c528985e.png";